module.exports = __webpack_public_path__ + "static/media/20.a8b92bf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/20.png
// module id = 1394
// module chunks = 0